import * as React from 'react';
import gettext from '@sdk/lang/gettext';
import Text14 from '@sdk/components/ui/typography/Text14';
import Button from '@sdk/components/ui/buttons/Button';
import { SUBSCRIPTION_NAMES } from '@sdk/account/constants';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';
import Row from '@sdk/components/ui/spacing/Row';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import useConfig from '@sdk/config/useConfig';

import CheckmarkGray from '../../assets/svg/UI/checkmark-gray.svg';

import { CheckmarkWithText } from './billingPlans.styles';

type Props = {
  billingPlans: Record<string, unknown>;
  level: number;
  isPlanAnnual: boolean;
  center?: boolean;
  isAlreadySubscribed?: boolean;
  isSubscriptionCancellationPeriod?: boolean;
  goToPurchase: (plan: number, isAnnual: boolean) => void;
  upgradeSubscriptionLevel?: () => void;
  isToastBilling: boolean;
};

const BillingPlanActions: React.FC<React.PropsWithChildren<Props>> = ({
  level,
  billingPlans,
  isPlanAnnual,
  center,
  goToPurchase,
  isAlreadySubscribed,
  isSubscriptionCancellationPeriod,
  upgradeSubscriptionLevel,
  isToastBilling,
}) => {
  const { TOAST_SALES_URL } = useConfig();
  const onToastUpgrade = () => {
    window.open(TOAST_SALES_URL, '_blank');
  };

  if (billingPlans.status[level].isCurrent) {
    return (
      <CheckmarkWithText mTop={30} center={center}>
        <CheckmarkGray />
        <Text14 left={10} semiBold themeColor={ThemeColorType.gray}>
          {gettext('Current plan')}
        </Text14>
      </CheckmarkWithText>
    );
  }

  if (billingPlans.status[level].hideCallToAction) {
    return null;
  }

  return isToastBilling ? (
    <Row mTop={30}>
      <Button onClick={onToastUpgrade} buttonType={ButtonType.primary}>
        {gettext('Visit Toast Shop to upgrade')}
      </Button>
    </Row>
  ) : (
    <Row mTop={20}>
      <Button
        buttonType={ButtonType.primary}
        onClick={() =>
          isAlreadySubscribed || isSubscriptionCancellationPeriod
            ? upgradeSubscriptionLevel()
            : goToPurchase(level, isPlanAnnual)
        }>
        {gettext('Purchase')} {SUBSCRIPTION_NAMES[level]}
      </Button>
    </Row>
  );
};

export default BillingPlanActions;
